<template>
    <nav class="navbar">
        <div class="container hide-desktop hide-mobile">
            <router-link class="navbar-brand" to="/"><img src="@/assets/img/logo_black.svg" width="38"
                                                              style="margin-right: 5px;"></router-link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText"
                    aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                <img src="@/assets/img/menu-bar.svg" width="25" />
            </button>
            <div class="collapse navbar-collapse" id="navbarText">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <router-link class="nav-link" to="/artists">Artists</router-link>
                    </li>
                    <li class="nav-item active">
                        <router-link class="nav-link" to="/stages">Stages</router-link>
                    </li>
                    <li class="nav-item dropdown a-drop">
                        <a href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Campaigns <img src="@/assets/img/down.svg"/></a>
                        <div class="dropdown-menu dropdown-menu-right pb-0" aria-labelledby="dropdownMenuButton">
                            <router-link class="nav-link" :to="`/campaign/`+list._id" v-for="list in campaignList" :key="list._id">{{list.campaign}}</router-link>
                        </div>
                    </li>
                    <li class="nav-item dropdown a-drop">
                        <a href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">About <img src="@/assets/img/down.svg"/></a>
                        <div class="dropdown-menu dropdown-menu-right pb-0" aria-labelledby="dropdownMenuButton">
                            <!--<router-link class="nav-link" to="/about">Team</router-link>-->
                            <!--<router-link class="nav-link" to="/press">Press</router-link>-->
                            <router-link class="nav-link" to="/events/all">Events</router-link>
                            <router-link class="nav-link" to="/contact">Contact</router-link>
                        </div>
                    </li>
                </ul>
                <ul class="navbar-nav signup-link" v-if="!logedIn">
                    <li class="nav-item">
                        <router-link class="nav-link" to="/login">Log In</router-link>
                    </li>
                    <li class="nav-item signup-link">
                        <router-link class="nav-link" to="/signup">Sign Up</router-link>
                    </li>
                </ul>
                <ul class="navbar-nav" v-if="logedIn">
                    <li class="nav-item notification-icon" style="margin-right: 15px;">
                        <router-link class="nav-link" to="/notification/"><span v-if="notificatoinCount">{{notificatoinCount}}</span><img src="@/assets/img/notification-icon.svg"/></router-link>
                    </li>
                    <li class="nav-item notification-icon message-li" style="margin-right: 15px;position: relative;">
                        <a class="nav-link message-icon" v-on:click="messageClick" href="javascript:void(0)"><i v-if="messageActive"></i><img src="@/assets/img/mail.svg"/></a>
                        <div class="messages-blk hide-blk">
                            <p class="no-m" v-if="!messageList.length">No messages!</p>
                            <ul class="message-user-list" v-if="messageList.length">
                                <li v-for="list in messageList" :key="list._id" :data-id="list._id">
                                    <router-link :to="`/artists/` + list.senderId._id + `/message`" v-if="senderId == list.receiverId._id" :class="{'unread-message' : (!list.read && (list.senderId._id !== receiverId))}">
                                        <div class="profile-user-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.receiverId.profiles[0].images[0].profileImageFile})` }"></div>
                                        <div class="message-user-detail">
                                            <h3 v-if="senderId != list.receiverId._id">{{list.receiverId.name}}</h3>
                                            <h3 v-if="senderId == list.receiverId._id">{{list.senderId.name}}</h3>
                                            <p>{{list.message}}</p>
                                        </div>
                                    </router-link>
                                    <router-link :to="`/artists/` + list.receiverId._id + `/message`" v-if="senderId != list.receiverId._id">
                                        <div class="profile-user-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.receiverId.profiles[0].images[0].profileImageFile})` }"></div>
                                        <div class="message-user-detail">
                                            <h3 v-if="senderId != list.receiverId._id">{{list.receiverId.name}}</h3>
                                            <h3 v-if="senderId == list.receiverId._id">{{list.senderId.name}}</h3>
                                            <p>{{list.message}}</p>
                                        </div>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li class="nav-item dropdown account-drop">
                        <a href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <!--<img :src="profileImage" :class="activePro"/>-->
                            <div :style="{ backgroundImage: `url(${profileImage})` }" :class="activePro" class="background-fit"></div>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                            <router-link class="nav-link" :to="`/artists/` + userId">My Profile</router-link>
                            <!--<span style="font-size: 12px;font-weight: 600;padding: 0px 0px 15px;color: #5B3C51;" class="nav-link" >{{userName}}</span>-->
                            <router-link class="nav-link" to="/stage/create/">Create a Stage</router-link>
                            <router-link class="nav-link" to="/stage/join-stage/">Join a Stage</router-link>
                            <router-link class="nav-link" to="/reset-password">Reset Password</router-link>
                            <router-link class="nav-link" to="/login/">Sign Out</router-link>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="container mobile-menu">
            <router-link class="navbar-brand" to="/" style="padding-top: 0; padding-bottom: 0;"><img src="@/assets/img/logo_black.svg" width="40"
                                                          style="margin-right: 20px;"></router-link>
            <ul class="list-inline m-men">
                <!--<li>-->
                    <!--<router-link class="nav-link" to="/notification/"><span v-if="notificatoinCount">{{notificatoinCount}}</span><img src="@/assets/img/notification-icon.svg"/></router-link>-->
                <!--</li>-->
                <li>
                    <a href="javascript:void(0)" id="navbarTextTwo" data-toggle="collapse" data-target="#navbarText2"
                       aria-controls="navbarText2" aria-expanded="false" aria-label="Toggle navigation">
                        <div :style="{ backgroundImage: `url(${profileImage})` }" :class="activePro" class="background-fit"></div>
                    </a>
                </li>
                <li>
                    <button class="navbar-toggler" id="navbarTextOne" type="button" data-toggle="collapse" data-target="#navbarText1"
                            aria-controls="navbarText1" aria-expanded="false" aria-label="Toggle navigation">
                        <img src="@/assets/img/menu-bar.svg" width="25"/>
                    </button>
                </li>
            </ul>
            <div class="collapse navbar-collapse" id="navbarText1">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <router-link class="nav-link" to="/artists">Artists</router-link>
                    </li>
                    <li class="nav-item active">
                        <router-link class="nav-link" to="/stages">Stages</router-link>
                    </li>
                    <li class="nav-item">
                        <button class="navbar-toggler navbarText3" type="button" data-toggle="collapse" data-target="#navbarText3"
                                aria-controls="navbarText3" aria-expanded="false" aria-label="Toggle navigation">
                            Campaigns <img src="@/assets/img/down.svg"/>
                        </button>
                        <div class="collapse navbar-collapse" id="navbarText3">
                            <ul class="navbar-nav mr-auto">
                                <li class="nav-item active">
                                    <router-link class="nav-link" :to="`/campaign/`+list._id" v-for="list in campaignList" :key="list._id">{{list.campaign}}</router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li class="nav-item text-center" style="margin-top: 5px;">
                        <button class="navbar-toggler navbarText3" type="button" data-toggle="collapse" data-target="#navbarText4"
                                aria-controls="navbarText4" aria-expanded="false" aria-label="Toggle navigation">
                            About <img src="@/assets/img/down.svg"/>
                        </button>
                        <div class="collapse navbar-collapse" id="navbarText4">
                            <ul class="navbar-nav mr-auto">
                                <li class="nav-item active">
                                    <!--<router-link class="nav-link" to="/press">Press</router-link>-->
                                    <router-link class="nav-link" to="/about">Who We Are</router-link>
                                    <router-link class="nav-link" to="/events/all">Events</router-link>
                                    <router-link class="nav-link" to="/contact">Contact</router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <ul class="navbar-nav" v-if="!logedIn">
                    <li class="nav-item signup-link">
                        <router-link class="nav-link" to="/login">Log In</router-link>
                    </li>
                    <li class="nav-item signup-link">
                        <router-link class="nav-link" to="/signup">Sign Up</router-link>
                    </li>
                </ul>
            </div>
            <div class="collapse navbar-collapse" id="navbarText2">
                <ul class="navbar-nav" v-if="!logedIn">
                    <li class="nav-item">
                        <router-link class="nav-link" to="/login">Log In</router-link>
                    </li>
                    <li class="nav-item signup-link">
                        <router-link class="nav-link" to="/signup">Sign Up</router-link>
                    </li>
                </ul>
                <ul class="navbar-nav m-d" v-if="logedIn">
                    <!--<li>-->
                        <!--<span style="font-size: 12px;font-weight: 600;padding: 8px 0px 15px;color: #ffffff;" class="nav-link" >{{userName}}</span>-->
                    <!--</li>-->
                    <li>
                        <router-link class="nav-link" :to="`/artists/` + userId">My Profile</router-link>
                    </li>
                    <!--<li>-->
                        <router-link class="nav-link" to="/stage/create/">Create a Stage</router-link>
                    <!--</li>-->
                    <li>
                        <router-link class="nav-link" to="/campaign/5f0830801d84d464c6346ba8">Join a Stage</router-link>
                    </li>
                    <li>
                        <router-link class="nav-link" to="/login/">Sign Out</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

</template>


<style>
    body {
        font-family: 'Barlow Condensed', sans-serif;
    }
</style>

<script>
    import $ from "jquery"
    import axios from 'axios'
    import router from '../router'
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)
    import profileImage from '@/assets/img/user.svg'
    export default {
        name: 'Header',
        methods: {
            messageClick: function(event){
                if($(event.target).hasClass('message-icon') || $(event.target).parents().hasClass('message-icon')){
                    $('.messages-blk').toggleClass('hide-blk')
                }
            }
        },
        mounted() {
            axios
                .get('/getAllCampaign', {})
                .then(response => {
                    this.campaignList = response.data
                })
                .catch(error => console.log(error))
            $(document).click(function (event) {
                // $('.navbar-collapse').collapse('hide')
            })
            $('.navbar-collapse').collapse('hide')
            $('#navbarTextOne').click(function () {
                $('#navbarText2').collapse('hide')
            });
            $('#navbarTextTwo').click(function () {
                $('#navbarText1').collapse('hide')
            });
            $('#app').hide()
            $('#app').fadeIn()
            var lastScrollTop = 0
            $(window).scroll(function (event) {
                var st = $(this).scrollTop()
                if(st > 50){
                    if (st > lastScrollTop) {
                        // downscroll code
                        $('nav.navbar').css('top', -80)
                    } else {
                        // upscroll code
                        $('nav.navbar').css('top', 0)
                    }
                    lastScrollTop = st
                } else {
                    $('nav.navbar').css('top', 0)
                }
            })

            let $this = this
            if(this.$route.name == 'Login'){
                localStorage.removeItem('cbs_usertoken')
            } else {
                var userData = localStorage.getItem('cbs_usertoken')
                if(userData){
                    this.logedIn = true
                    userData = JSON.parse(userData)
                    this.userId = userData.user.id
                    this.userName = userData.user.name
                    if(userData.user.profileImage){
                        this.profileImage = this.imageUrl + userData.user.profileImage
                        this.activePro = 'active'
                    }

                    if(this.$route.name == 'Notification'){
                        axios.post('/updateNotificationCount', {
                            userId: userData.user.id
                        },{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": userData.token
                            }
                        }).then(function (response) {

                        }).catch(err => {
                            Vue.$toast.open(
                                {
                                    message: err.response.data,
                                    type: 'error',
                                    position: 'top-right'
                                    // all other options
                                }
                            )
                            router.push({ name: 'Login' })
                        })
                    } else {
                        axios
                            .get('/getNotificationRead', {
                                params: {
                                    userId: userData.user.id
                                },
                                headers: {
                                    "content-type": "application/json",
                                    "x-api-key": userData.token
                                }
                            })
                            .then(response => {
                                let ownerCount = 0
                                let appliedArtist = 0
                                $.each(response.data, function (key, value) {
                                     if((value.response === 'pending') && (value.stageOwner === userData.user.id)){
                                         ownerCount = ownerCount + 1
                                     } else if(!value.read && (value.appliedArtist === userData.user.id)){
                                         appliedArtist = appliedArtist + 1
                                     }
                                })

                                this.notificatoinCount = appliedArtist + ownerCount;
                                axios
                                    .get('/getNotificationForNewStage', {
                                        headers: {
                                            "content-type": "application/json",
                                            "x-api-key": userData.token
                                        }
                                    })
                                    .then(response => {
                                        let $this = this;
                                        if(response.data){
                                            $.each(response.data, function (key, value) {
                                                if(!value.read){
                                                    $this.notificatoinCount = $this.notificatoinCount + 1;
                                                }
                                            })
                                        }
                                    })
                                    .catch(err => {
                                    })
                            })
                            .catch(err => {
                                Vue.$toast.open(
                                    {
                                        message: err.response.data,
                                        type: 'error',
                                        position: 'top-right'
                                        // all other options
                                    }
                                )
                                router.push({ name: 'Login' })
                            })
                    }
                    this.senderId = userData.user.id
                    this.sendername = userData.user.name
                    this.senderemail = userData.user.email
                    axios
                        .get('/getMessageArtistsList', {
                            params: {
                                senderId: userData.user.id
                            }
                        })
                        .then(response => {
                            console.log(response)
                            this.loading = false
                            let data = {}
                            let finalData = []
                            $.each(response.data, function (key, value) {
                                if(value.senderId.email !== $this.senderemail){
                                    data[value.senderId._id] = value
                                } else if(value.receiverId.email !== $this.senderemail){
                                    data[value.receiverId._id] = value
                                }
                            })

                            $.each(data, function (key, value) {
                                console.log(value)
                                if(!value.read){
                                    $this.messageActive = true
                                }
                                finalData.push(value)
                            })

                            this.messageList = finalData
                            console.log(this.messageList)
                        })
                        .catch(error => console.log(error))
                }
            }
        },

        data() {
            return {
                msg: 'Welcome to Your Vue.js App',
                profileImage: profileImage,
                imageUrl: process.env.imageUrl,
                activePro: '',
                logedIn: false,
                userId: '',
                campaignList: '',
                userName: '',
                messageList: '',
                receiverId: '',
                artistBg: '',
                messageActive: false,
                notificatoinCount: 0
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue